import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48ee860a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "block relative" }
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block w-9 h-4 rounded-full shadow-inner line" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block dot absolute w-6 h-6 rounded-full shadow -left-1 -top-1 transition" }, null, -1))
const _hoisted_6 = { class: "block ml-3 text-gray-700 text-default" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    for: _ctx.id,
    class: "flex items-center cursor-pointer"
  }, [
    _createElementVNode("span", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: _ctx.id,
        type: "checkbox",
        class: "sr-only",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
      }, null, 8, _hoisted_3), [
        [_vModelCheckbox, _ctx.value]
      ]),
      _hoisted_4,
      _hoisted_5
    ]),
    _createElementVNode("span", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 8, _hoisted_1))
}